import { LazyLoad } from 'app/utils';

export const SystemConfigFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.SystemConfigFormPage,
);
